module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYEAAAAGCAYAAAAlmyLwAAAAAXNSR0IArs4c6QAAAJlJREFUaEPt2SEOgCAYhuGPYHY2Ny/gFfQqHIXMUbgKyWOYDY5ocGYLgcC/veR/7N1DYAO3+Xg4aZa9VXIKq71sihFAAIF+BNzu4yVp6iepuuTJKQzV0wwigAACCPwEvkvglLQYtLlzCqPBbpIRQACBbgQsXwLdIBKCAAIIGBUoPAcZPTmyEUAAgRYCjo/hFozsgQACCNgUeAHXPxwUbqjUpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sy/sy_dx.png
// module id = N6Ko
// module chunks = 1